import { gsap } from "gsap";
import Draggable from "gsap/Draggable";

gsap.registerPlugin(Draggable);

export default class SubscriptionCarousel {
    constructor() {
        this.carouselTrack = document.querySelector(".carousel-track");
        this.items = document.querySelectorAll(".subscription-item");
        this.draggableInstance = null;
        this.isDesktop = window.innerWidth >= 1200;
        this.init();
    }

    init() {
        if (!this.carouselTrack || !this.items.length) return;

        this.visibleItems = window.innerWidth >= 768 ? 2 : 1;
        this.itemWidth = this.carouselTrack.offsetWidth / this.visibleItems;

        this.setupDraggable();

        document.addEventListener("tabChanged", this.handleTabChange.bind(this));
        window.addEventListener("resize", this.handleResize.bind(this));
    }

    setupDraggable() {
        gsap.registerPlugin(Draggable);

        if (window.innerWidth >= 1200) {
            this.disableDraggable();
            return;
        }

        this.draggableInstance = Draggable.create(this.carouselTrack, {
            type: "x",
            bounds: {
                minX: -(this.items.length - this.visibleItems) * this.itemWidth,
                maxX: 0,
            },
            inertia: true,
            onDragEnd: () => this.snapToClosestItem(),
        })[0];
    }

    snapToClosestItem() {
        const closestIndex = Math.round(-this.draggableInstance.x / this.itemWidth);
        gsap.to(this.carouselTrack, {
            x: -closestIndex * this.itemWidth,
            duration: 0.5,
            ease: "power2.out",
        });
    }

    handleTabChange() {
        const currentPosition = gsap.getProperty(this.carouselTrack, "x");
        gsap.set(this.carouselTrack, { x: currentPosition });
    }

    handleResize() {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth >= 1200;

        this.visibleItems = window.innerWidth >= 768 ? 2 : 1;
        this.itemWidth = this.carouselTrack.offsetWidth / this.visibleItems;

        if (this.isDesktop && !wasDesktop) {
            this.disableDraggable();
        } else if (!this.isDesktop && wasDesktop) {
            this.setupDraggable();
        }
    }

    disableDraggable() {
        if (this.draggableInstance) {
            this.draggableInstance.kill();
            this.draggableInstance = null;
        }
        gsap.set(this.carouselTrack, { x: 0 });
    }
}
